module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_plan_included_03_black-f41cded842a9eb586bc8e5848d3b90a7.png";